import { loadNg1Module, ngmodule } from '../../bootstrap/ngmodule'
import { umsEyeCatcher } from './components/eye-catcher/eye-catcher.component'
import { EyeCatcherService } from './components/eye-catcher/eye-catcher.service'
import { umsHintr } from './components/hintr/hintr.component'
import { umsLoadr } from './components/loadr/loadr.component'
import { umsMaxContainer } from './components/max-container/ums-max-container.component'
import { umsSearchbar } from './components/searchbar/searchbar.component'
import { umsSubHeader } from './components/sub-header/ums-sub-header.component'
import { umsToolbar } from './components/toolbar/toolbar.component'
import { umsWizardStep } from './components/wizard-step/wizard-step.component'
import { input, umsSubmit } from './directives/ums-forms.directive'
import { umsValidateEmail } from './directives/ums-validate-email.directive'
import { umsValidatePhone } from './directives/ums-validate-phone.directive'
import { searchJsonFilter } from './filters/search-json.filter'
import { AuthFactory, LoadingFactory, authConfigBlock, authRunBlock } from './services/auth.service'
import { CompanyService } from './services/company.service'
import { CustomerFactory } from './services/customer.factory'
import { CustomerService } from './services/customer.service'
import { DownloadService } from './services/download.service'
import { OrderFactory } from './services/order.factory'
import { SessionService } from './services/session.service'
import { UserFactory } from './services/user.factory'
import { UserService } from './services/user.service'

const componentsAppModule = {
  components: {
    umsMaxContainer,
    umsSubHeader,
    umsToolbar,
    umsSearchbar,
    umsEyeCatcher,
    umsLoadr,
    umsWizardStep,
    umsHintr,
  },
  services: { EyeCatcherService, DownloadService, SessionService, UserService, CustomerService, CompanyService },
  factories: { AuthFactory, LoadingFactory, CustomerFactory, UserFactory, OrderFactory },
  configBlocks: [authConfigBlock],
  runBlocks: [authRunBlock],
  directives: { umsValidateEmail, umsValidatePhone, umsSubmit, input },
  filters: { searchJsonFilter },
}

loadNg1Module(ngmodule, componentsAppModule)



// WEBPACK FOOTER //
// ./app/shared/shared.module.js